import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints,
} from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MobilBreakPoints } from '../app.models';

@Injectable({ providedIn: 'root' })
export class MobileBreakPointsService {
  constructor(private _breakpointObserver: BreakpointObserver) {}

  public mobileBreakPoints$ = this._breakpointObserver
    .observe([MobilBreakPoints.MW])
    .pipe(
      startWith({
        matches: this._breakpointObserver.isMatched([MobilBreakPoints.MW]),
        breakpoints: {
          [MobilBreakPoints.MW]: this._breakpointObserver.isMatched(
            MobilBreakPoints.MW
          ),
        },
      }),
      map(
        (matches: BreakpointState) => matches.breakpoints[MobilBreakPoints.MW]
      )
    );

  public mobileBPvhOffset$ = this._breakpointObserver.observe([
    Breakpoints.HandsetPortrait,
    Breakpoints.HandsetLandscape,
  ]);

  public tabletOrMobileBreakPoints$  =  this._breakpointObserver
  .observe([MobilBreakPoints.Tablet])
  .pipe(
    startWith({
      matches: this._breakpointObserver.isMatched([MobilBreakPoints.Tablet]),
      breakpoints: {
        [MobilBreakPoints.Tablet]: this._breakpointObserver.isMatched(
          MobilBreakPoints.Tablet
        ),
      },
    }),
    map(
      (matches: BreakpointState) => matches.breakpoints[MobilBreakPoints.Tablet]
    )
  );

}
